import React, { useState } from 'react';
import { login, setToken } from '../api';

export default function Login({ onLogin }) {
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await login(form.username, form.password);
      setToken(data.token);
      onLogin({ username: data.username });
    } catch {
      setError('Identifiants incorrects. Réessayez.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex',
      background: 'var(--bg)',
    }}>
      {/* Panneau gauche décoratif */}
      <div style={{
        width: '45%', background: 'var(--text)',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        padding: 60, position: 'relative', overflow: 'hidden'
      }}>
        {/* Lignes décoratives */}
        <div style={{
          position: 'absolute', inset: 0,
          backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 60px, rgba(255,255,255,0.03) 60px, rgba(255,255,255,0.03) 61px)',
        }} />
        <div style={{ position: 'relative', textAlign: 'center' }}>
          <div style={{
            fontFamily: 'var(--font-display)', fontSize: 52,
            color: '#ffffff', fontWeight: 700, letterSpacing: 1,
            lineHeight: 1, marginBottom: 16
          }}>
            Admin<span style={{ color: '#c47c7c' }}>Films</span>
          </div>
          <div style={{
            width: 48, height: 2, background: '#8B1A1A',
            margin: '20px auto'
          }} />
          <div style={{
            fontFamily: 'var(--font-mono)', fontSize: 11,
            color: 'rgba(255,255,255,0.4)', letterSpacing: 5,
            textTransform: 'uppercase'
          }}>
            Gestion des licences
          </div>
        </div>
      </div>

      {/* Panneau droit formulaire */}
      <div style={{
        flex: 1, display: 'flex', alignItems: 'center',
        justifyContent: 'center', padding: 60
      }}>
        <div style={{ width: '100%', maxWidth: 420 }} className="fade-in">
          <div style={{ marginBottom: 48 }}>
            <h1 style={{
              fontFamily: 'var(--font-display)', fontSize: 32,
              fontWeight: 600, color: 'var(--text)', marginBottom: 8
            }}>Connexion</h1>
            <p style={{ color: 'var(--text-muted)', fontSize: 15 }}>
              Accès réservé aux administrateurs
            </p>
          </div>

          {error && (
            <div style={{
              padding: '14px 18px', marginBottom: 24,
              background: '#fdf2f2', border: '1px solid #f5c6c6',
              color: '#c0392b', borderRadius: 4, fontSize: 14
            }}>{error}</div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 20 }}>
              <label style={{
                display: 'block', fontFamily: 'var(--font-mono)',
                fontSize: 11, letterSpacing: 2, color: 'var(--text-muted)',
                textTransform: 'uppercase', marginBottom: 8, fontWeight: 500
              }}>Identifiant</label>
              <input
                type="text" autoFocus autoComplete="username"
                value={form.username}
                onChange={e => setForm(f => ({ ...f, username: e.target.value }))}
                style={{
                  width: '100%', padding: '14px 16px',
                  background: 'var(--bg-2)', border: '1.5px solid var(--border)',
                  color: 'var(--text)', fontSize: 15, outline: 'none',
                  transition: 'border-color 0.2s', borderRadius: 4
                }}
                onFocus={e => e.target.style.borderColor = 'var(--accent)'}
                onBlur={e => e.target.style.borderColor = 'var(--border)'}
              />
            </div>

            <div style={{ marginBottom: 32 }}>
              <label style={{
                display: 'block', fontFamily: 'var(--font-mono)',
                fontSize: 11, letterSpacing: 2, color: 'var(--text-muted)',
                textTransform: 'uppercase', marginBottom: 8, fontWeight: 500
              }}>Mot de passe</label>
              <input
                type="password" autoComplete="current-password"
                value={form.password}
                onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
                style={{
                  width: '100%', padding: '14px 16px',
                  background: 'var(--bg-2)', border: '1.5px solid var(--border)',
                  color: 'var(--text)', fontSize: 15, outline: 'none',
                  transition: 'border-color 0.2s', borderRadius: 4
                }}
                onFocus={e => e.target.style.borderColor = 'var(--accent)'}
                onBlur={e => e.target.style.borderColor = 'var(--border)'}
              />
            </div>

            <button
              type="submit" disabled={loading}
              style={{
                width: '100%', padding: '15px',
                background: 'var(--accent)', border: 'none',
                color: '#ffffff', fontSize: 13, fontWeight: 600,
                letterSpacing: 3, textTransform: 'uppercase',
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.7 : 1,
                transition: 'all 0.2s', borderRadius: 4,
                fontFamily: 'var(--font-mono)'
              }}
              onMouseEnter={e => { if (!loading) e.target.style.background = '#6d1414'; }}
              onMouseLeave={e => { if (!loading) e.target.style.background = 'var(--accent)'; }}
            >
              {loading ? 'Vérification...' : 'Se connecter'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
